import type { AppRouteRecordRaw } from '@/router/types'

export const customerManageConfigRoutes: AppRouteRecordRaw[] = [
  {
    path: 'customManageConfig',
    name: 'customManageConfig',
    component: () => import('@/views/systemManage/customManageConfig/index.vue'),
    meta: {
      title: '客户管理配置'
    },
    children: [
      {
        path: 'highSeasManageConfig',
        name: 'highSeasManageConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/highSeasManageConfig/index.vue'),
        meta: { title: '公海管理配置' }
      },
      {
        path: 'staffAutoAssignConfig',
        name: 'staffAutoAssignConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/staffAutoAssignConfig/index.vue'),
        meta: {
          title: '员工自动分配'
        }
      },
      {
        path: 'customerClassifyConfig',
        name: 'customerClassifyConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/customerClassifyConfig/index.vue'),
        meta: {
          title: '客户分类配置'
        }
      },
      {
        path: 'customerStageConfig',
        name: 'customerStageConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/customerStageConfig/index.vue'),
        meta: {
          title: '客户阶段配置'
        }
      },
      {
        path: 'customerTagsConfig',
        name: 'customerTagsConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/customerTagsConfig/index.vue'),
        meta: {
          title: '客户标签配置'
        }
      },
      {
        path: 'highSeaAutoAssignConfig',
        name: 'highSeaAutoAssignConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/HighSeaAutoAssignConfig/index.vue'),
        meta: {
          title: '公海自动分配'
        }
      },
      {
        path: 'recyclingRulesConfig',
        name: 'recyclingRulesConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/recyclingRulesConfig/index.vue'),
        meta: {
          title: '回收规则'
        }
      },
      {
        path: 'customerSourceConfig',
        name: 'customerSourceConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/customerSourceConfig/index.vue'),
        meta: {
          title: '客户来源管理'
        }
      },
      {
        path: 'customerSourceNewConfig',
        name: 'CustomerSourceNewConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/customerSourceNewConfig/index.vue'),
        meta: {
          title: '客户来源配置'
        }
      },
      {
        path: 'systemGlobalConfig',
        name: 'systemGlobalConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/systemGlobalConfig/index.vue'),
        meta: {
          title: '系统全局配置'
        }
      },
      {
        path: 'staffDistributeSwitch',
        name: 'staffDistributeSwitch',
        component: () =>
          import('@/views/systemManage/customManageConfig/staffDistributeSwitch/index.vue'),
        meta: {
          title: '员工派单开关'
        }
      },
      {
        path: 'deleteReasonConfig',
        name: 'deleteReasonConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/deleteReasonConfig/index.vue'),
        meta: {
          title: '删除原因配置'
        }
      },
      {
        path: 'followRecordConfig',
        name: 'followRecordConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/followRecordConfig/index.vue'),
        meta: {
          title: '跟进记录配置'
        }
      },
      {
        path: 'staffPrivateConfig',
        name: 'staffPrivateConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/staffPrivateConfig/index.vue'),
        meta: {
          title: '员工私库上限配置'
        }
      },
      {
        path: 'contactConfig',
        name: 'contactConfig',
        component: () => import('@/views/systemManage/customManageConfig/contactConfig/index.vue'),
        meta: {
          title: '联系情况配置'
        }
      },
      {
        path: 'commonWordsConfig',
        name: 'commonWordsConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/commonWordsConfig/index.vue'),
        meta: {
          title: '常用语配置'
        }
      },
      {
        path: 'visitTagsConfig',
        name: 'VisitTagsConfig',
        component: () =>
          import('@/views/systemManage/customManageConfig/visitTagsConfig/index.vue'),
        meta: {
          title: '回访标签配置'
        }
      }
      // {
      //   path: 'workbenchConfiguration',
      //   name: 'WorkbenchConfiguration',
      //   component: () => import('@/views/systemManage/customManageConfig/workbenchConfiguration/index.vue'),
      //   meta: {
      //     title: '工作台配置'
      //   }
      // }
      // {
      //   path: 'customerDetail',
      //   name: 'CustomerDetail',
      //   component: () => import('@/views/customerManage/customerDetail/index.vue'),
      //   meta: { title: '客户详情' }
      // }
    ]
  }
]
